import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import Balance from '../Balance';
import globalTranslations from '../../../../i18n/globalTranslations';
import CustomerUserStore from '../../../../store/CustomerUserStore';
import BalanceUser from '../../../../models/BalanceUser';
import ContentForState from '../../../loader/ContentForState';

@observer
export class BalanceUserInfo extends Component {
  handlePaymentClick = () => {
    this.props.onPayment();
  };

  onInfoUpdate = () => {
    this.props.onInfoUpdate();
  };

  getInformation = () => {
    const { user } = this.props;

    return (
      <div className="BalanceUserInfo">
        <div className="BalanceUserInfo__header">
          <FormattedMessage {...globalTranslations.fullNameTitle} />
        </div>
        <div className="BalanceUserInfo__name">
          {user.firstname} {user.lastname}
        </div>
        <div className="BalanceUserInfo__header">
          <FormattedMessage {...globalTranslations.balanceUserCurrentBalance} />
        </div>
        <div className="BalanceUserInfo__balance">
          <Balance
            amount={user.account_balance}
            currencyType={user.account_currency}
          />
        </div>
      </div>
    );
  };

  render() {
    const { customerUserStore, infoState } = this.props;

    return (
      <ContentForState
        state={infoState}
        error={customerUserStore.lastError}
        forLoaded={() => this.getInformation()}
      />
    );
  }
}

BalanceUserInfo.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  infoState: PropTypes.string.isRequired,
  user: modelOf(BalanceUser).isRequired,
  onInfoUpdate: PropTypes.func
};

export default inject('customerUserStore')(BalanceUserInfo);



// WEBPACK FOOTER //
// ./src/components/my-account/BalanceUser/BalanceUserInfo/index.jsx